import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import HeaderLounge from '../components/HeaderLounge';
import LeftLounge from '../components/LeftLounge';
import RightLounge from '../components/RightLounge';
import WdwLeftLounge from '../components/WdwLeftLounge';
import WdwRightLounge from '../components/WdwRightLounge';
import ModernThemeBanner from '../components/ModernThemeBanner';
import { ENABLE_SCROLL_TO_TOP } from '../constants/features';
{
  /* <Outlet/> */
}

export default function LoungeLayout() {
  const location = useLocation();
  const pathArray = location.pathname.split('/');

  useEffect(() => {
    if (ENABLE_SCROLL_TO_TOP) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  // Modern theme: scope all overrides under `.mw-lounge-modern`. Applied only
  // to Disneyland-side routes AND only when the user has opted in via the
  // floating toggle (localStorage flag). Disney World and any user who hasn't
  // opted in keep the existing design.
  const isDisneylandRoute =
    pathArray[1] === 'disneyland' ||
    pathArray[1] === 'loungeland' ||
    pathArray[1] === 'club333';
  // Modern lounge is the default; only an explicit "off" opts out.
  let modernEnabled = true;
  try {
    modernEnabled = localStorage.getItem('mw_modern_lounge') !== 'off';
  } catch {
    /* private mode etc — treat as default (on) */
  }
  const bgClassName = `mousewait-bg${
    isDisneylandRoute && modernEnabled ? ' mw-lounge-modern' : ''
  }`;

  return (
    <div className={bgClassName}>
      {/*===== MW-Deshborad-sec Start =======*/}
      <div className='mousewait-deshborad'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='des-main-sec'>
              {/* ===leftbar start=== */}
              {pathArray[1] === 'loungeland' ||
              pathArray[1] === 'disneyland' || pathArray[1] === 'club333' ? (
                <LeftLounge />
              ) : (
                <WdwLeftLounge />
              )}

              {/* ===leftbar end=== */}
              {/* ===mid-sec start=== */}
              <Outlet />
              {/* ===mid-sec End=== */}
              {/* ===rightbar start=== */}
              {pathArray[1] === 'loungeland' ||
              pathArray[1] === 'disneyland' ? (
                <RightLounge />
              ) : (
                <WdwRightLounge />
              )}

              {/* ===rightbar End=== */}
            </div>
          </div>
        </div>
      </div>
      {isDisneylandRoute && <ModernThemeBanner />}
    </div>
  );
}
